"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var idm_crosscutting_concepts_frontend_1 = require("@synisys/idm-crosscutting-concepts-frontend");
/**
 * Action with additional indexes of related states in {@link ProcessStructureDto#states}
 */
var ActionIndexedDto = /** @class */ (function () {
    function ActionIndexedDto(id, name, description, initialStateId, targetStateId, initialStateIndex, targetStateIndex, formId) {
        this._id = id;
        this._name = name;
        this._description = description || new Map();
        this._initialStateId = initialStateId;
        this._targetStateId = targetStateId;
        this._initialStateIndex = initialStateIndex;
        this._targetStateIndex = targetStateIndex;
        this._formId = formId;
    }
    ActionIndexedDto.prototype.getId = function () {
        return this._id;
    };
    ActionIndexedDto.prototype.getName = function () {
        return new idm_crosscutting_concepts_frontend_1.MultilingualString(this._name);
    };
    ActionIndexedDto.prototype.getDescription = function () {
        return new idm_crosscutting_concepts_frontend_1.MultilingualString(this._description);
    };
    ActionIndexedDto.prototype.getNameMap = function () {
        return this._name;
    };
    ActionIndexedDto.prototype.getDescriptionMap = function () {
        return this._description;
    };
    ActionIndexedDto.prototype.getInitialStateId = function () {
        return this._initialStateId;
    };
    ActionIndexedDto.prototype.getTargetStateId = function () {
        return this._targetStateId;
    };
    ActionIndexedDto.prototype.getInitialStateIndex = function () {
        return this._initialStateIndex;
    };
    ActionIndexedDto.prototype.getTargetStateIndex = function () {
        return this._targetStateIndex;
    };
    ActionIndexedDto.prototype.getFormId = function () {
        return this._formId;
    };
    ActionIndexedDto.prototype.toJsonObject = function () {
        var nameObject = {};
        var descriptionObject = {};
        this._name.forEach(function (value, key) {
            nameObject[key] = value;
        });
        this._description.forEach(function (value, key) {
            descriptionObject[key] = value;
        });
        return {
            id: this._id,
            name: nameObject,
            multilingualDescription: descriptionObject,
            initialStateId: this._initialStateId,
            targetStateId: this._targetStateId,
            initialStateIndex: this._initialStateIndex,
            targetStateIndex: this._targetStateIndex,
            formId: this._formId
        };
    };
    ActionIndexedDto.prototype.toJson = function () {
        return JSON.stringify(this.toJsonObject());
    };
    return ActionIndexedDto;
}());
exports.ActionIndexedDto = ActionIndexedDto;
//# sourceMappingURL=action-indexed.dto.js.map